import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
// import "@radix-ui/themes/styles.css";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";

const mainTheme = {
  branding: {
    bannerColor: "#173457",
    backgroundColor: "#bfd9e9",
    bgColorHover: "#f0f0f0",
    textColor: "#fff",
    color: "#fff",
    borderColor: "#ddd",
    lightBlue: "#bbdefb",
    voilet: "#c5cae8",
  },
  colors: {
    primary: "#0069a6",
    background: "#f5f5f5",
    text: "#000",
    error: "#d32f2f",
    success: "#008001",
    info: "#2D8AD2",
    warning: "#F1CC01",
    helpText: "#666",
  },
  button: {
    color: "#FFF",
    background: "#0069a6",
    hover: "#173457",
    disabled: "#E8E8E8",
  },
  breakpoints: {
    mobile: "600px",
  },
};

if (process.env.NODE_ENV !== "development") {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ErrorBoundary>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        // transition=Bounce
      />
      {/* <Theme
        accentColor="crimson"
        grayColor="sand"
        radius="large"
        scaling="95%"
      > */}
      <ThemeProvider theme={mainTheme}>
        <AuthProvider>
          <LanguageProvider>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </LanguageProvider>
        </AuthProvider>
      </ThemeProvider>
      {/* </Theme> */}
    </ErrorBoundary>
  </BrowserRouter>,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
